<template>
    <b-container>
        Product
        <b-row class="mb-3 mt-1">
            
            <b-col class="mb-1" sm="12">
                <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon mr-1"
                v-b-modal.modal-list-product
                >
                Select Product
                </b-button>

            </b-col>
            <b-col sm="8" v-if="content.relatedProduct.length > 0">
                <b-badge class="mr-1" variant="secondary" v-for="(data, index) in content.relatedProduct" :key="index">
                <span> {{ data.PRODUCT }} </span>
                <feather-icon
                    @click="removeRelatedProductItem(data.KODE)"
                    icon="XIcon"
                    class="mr-25"
                    color="danger"
                />
                </b-badge>
            </b-col>
        </b-row>
        <b-modal
        id="modal-list-product"
        ok-only
        ok-title="Select"
        scrollable
        size="lg"
        @ok="setSelectedProduct()"
        >
            <product-list :setItem="setTempSelectedRelatedProduct"/>
        </b-modal>
    </b-container>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { BModal } from 'bootstrap-vue'
import { BLink, BImg, BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput, BButton, BProgress, BCardText, BDropdown, BDropdownItem, BOverlay, BBadge } from 'bootstrap-vue'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Product from './product.vue'
export default {
    props: {
        content: Object,
        options: Object,
        methods: Object,
    },
    components: {
        BCardText,
        BTabs,
        BTab,
        BLink,
        BImg,
        BCol,
        BContainer,
        BRow,
        BCard,
        BProgress,
        BCardText,
        BDropdown,
        BDropdownItem,
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BOverlay,
        BModal,
        BBadge,
        vSelect,
        quillEditor,
        'product-list': Product,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            warningProduct: false,
        }
    },
    mounted() {
    },
    methods: {
        setTempSelectedRelatedProduct(item) {
            let selected = null
            if (item.length > 0 ) {
                selected = item[0]
            }
            this.tempSelectedRelatedProduct = selected
        },
        setSelectedProduct() {
            this.content.relatedProduct.push(this.tempSelectedRelatedProduct)
            this.warningProduct = false
        },
        removeRelatedProductItem(kode) {
            this.content.relatedProduct = this.content.relatedProduct.filter(item => {
                return item.KODE !== kode
            })
        }
    }
}
</script>

<style scoped>
.dropzone {
    min-height: 250px;
}
/deep/ .dz-message:before {
    display: none;
}

.desc {
    color: #b8c2cc;
    font-size: 0.7rem;
    font-style: italic;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>